import styled, { css } from 'styled-components';

import { media } from '../../utils/media';
import { WIDTH_TYPES } from '../../utils/constants';

export const sansSerfifFamily =
  "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif";

export const sansSerifFont = css`
  font-family: ${sansSerfifFamily};
`;

export const serifFont = css`
  font-family: 'FreightText', Georgia, serif;
`;

export const Container = styled.div`
  position: absolute;
  display: flex;
  height: 100%;
  width: 100%;

  ${sansSerifFont}
`;

export const ContentWrapper = styled.div`
  height: 100%;
  overflow: auto;
  flex: 1 auto;
  position: fixed;
  width: 100%;

  ${media.desktop`
    position: static;
    width: unset;
  `}

  @media print {
    width: 100%;
    overflow: unset;
    flex: none;
    position: static;
  }
`;

export const ReportCover = styled.div`
  background: #ccc;
  height: 200px;
  margin-bottom: 30px;
`;

export const ReportContent = styled.div`
  width: calc(100vw - 318px);
  align-self: flex-end;
  padding: 60px;
`;

// REPORT LAYOUT

export const ContentSide = styled.div`
  --content-size: 40px;
  width: var(--content-size);
  min-width: var(--content-size);
  display: flex;
  justify-content: flex-end;
  margin-right: auto;

  ${media.tablet`
    justify-content: center;
  `}

  ${media.desktop`
    --content-size: 240px;
    display: block;
  `}

  @media print {
    --content-size: 240px;
    display: block;
  }
`;

export const ContentMain = styled.div`
  margin-left: 10px;

  ${media.desktop`
    margin-left: 50px;
  `};

  ${media.desktopWide`;
    margin-left: 100px;
  `};
`;

export const ContentContainer = styled.div`
  margin: 0 auto;
  display: flex;

  ${media.tablet`
    width: 640px;
  `};

  ${media.desktop`
    width: 800px;
  `};

  ${media.desktopWide`;
    width: 1000px;
  `};

  ${({ short, type }) =>
    (short || type === WIDTH_TYPES.SHORT) &&
    css`
      display: block;
      padding-left: 50px;

      ${media.desktop`
      padding-left: 290px;
    `};

      ${media.desktopWide`;
      padding-left: 340px;
    `};
    `};

  @media print {
    width: 1000px;
  }
`;
